import { ListItemIcon, Box, Typography, ListItemText, useTheme } from '@mui/material'
import React from 'react'
import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";

export interface CContent {
    icon?: FontAwesomeIconProps["icon"];
    labelText: string;
    valueText?: any;
}

const SidebarInputLabel = (props: CContent) => {

    const { icon, labelText, valueText } = props;
    const theme = useTheme()
    return (
        <Box pb={valueText ? 0 : 1} display="flex" alignItems="center">
            {icon &&
                <ListItemIcon>
                    <FontAwesomeIcon icon={icon} size="lg" color={theme.palette.primary.main} />
                </ListItemIcon>}

            <ListItemText
                sx={{ m: 0 }}
                primary={
                    <Typography color="textPrimary" fontWeight="600" variant="bodyMedium">
                        {labelText && labelText}
                    </Typography>
                }
                secondary={
                    <Typography color="textSecondary">
                        {valueText && valueText}
                    </Typography>
                }
            />
        </Box>)
}

export default SidebarInputLabel